import { getPlanTag } from 'utils/planTagMapper'
import { openSaasCheckout } from 'utils/saas-checkout-event'
import { track } from 'utils/tracking'

import * as S from './styles'
import { buildSalesWhatsappUrl } from './utils/buildSalesWhatsappUrl'
import {
  START_DESCRIPTION,
  START_FULL_PRICE,
  START_OFFER_BULLETS,
  START_OFFER_PRICE
} from './utils/smallPlanContent'

interface StartOfferCardProps {
  /** Fecha o modal antes de abrir o checkout. */
  onCheckout?: () => void
}

const formatPrice = (price: number) =>
  price.toLocaleString('pt-BR', { minimumFractionDigits: 2 })

const StartOfferCard = ({ onCheckout }: StartOfferCardProps) => {
  const planTag = getPlanTag('start')
  const salesUrl = buildSalesWhatsappUrl()

  // Variant 'small' é o mais visto do teste do paywall e era o único sem
  // nenhum clique medido — o checkout fica em outro domínio, então este é o
  // último ponto onde a intenção de assinar ainda é observável.
  const trackCta = (destination: 'checkout' | 'sales') =>
    track('upgrade_cta_clicked', {
      variant: 'small',
      selected_plan: 'start',
      destination
    })

  return (
    <S.Card>
      <S.CardOffer>
        <S.Badge bgcolor={planTag.bgcolor} fontColor={planTag.fontColor}>
          {planTag.text}
        </S.Badge>

        <S.PriceRow>
          <S.OldPrice>R$ {formatPrice(START_FULL_PRICE)}</S.OldPrice>
          <S.PriceValue>R$ {formatPrice(START_OFFER_PRICE)}</S.PriceValue>
          <S.PriceUnit>/mês</S.PriceUnit>
        </S.PriceRow>

        <S.PlanDescription>{START_DESCRIPTION}</S.PlanDescription>

        <S.CtaButton
          type="button"
          onClick={() => {
            trackCta('checkout')
            onCheckout?.()
            openSaasCheckout('start_offer', 'campaign_small')
          }}
        >
          Quero aproveitar
        </S.CtaButton>

        <S.SecondaryButton
          href={salesUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackCta('sales')}
        >
          Quero falar com vendas
        </S.SecondaryButton>

        <S.TrustList>
          <S.TrustItem>
            <S.TrustCheck>✓</S.TrustCheck>
            Sem fidelidade
          </S.TrustItem>
          <S.TrustItem>
            <S.TrustCheck>✓</S.TrustCheck>
            Ativação imediata
          </S.TrustItem>
        </S.TrustList>
      </S.CardOffer>

      <S.CardDivider />

      <S.CardBenefits>
        <S.FreeBillingsHighlight>
          <S.HighlightIcon>✓</S.HighlightIcon>
          <S.HighlightText>
            <S.HighlightTitle>
              <strong>50 cobranças grátis</strong> todos os meses
            </S.HighlightTitle>
            <S.HighlightSubtitle>&nbsp;via boleto e PIX</S.HighlightSubtitle>
          </S.HighlightText>
        </S.FreeBillingsHighlight>

        <S.SectionTitle>O que está incluso:</S.SectionTitle>

        <S.BulletList>
          {START_OFFER_BULLETS.map((bullet) => (
            <S.BulletItem key={bullet.text}>
              <S.Check>✓</S.Check>
              <S.BulletText>
                <span>{bullet.text}</span>
                {bullet.detail && (
                  <S.BulletDetail>({bullet.detail})</S.BulletDetail>
                )}
              </S.BulletText>
            </S.BulletItem>
          ))}
        </S.BulletList>
      </S.CardBenefits>
    </S.Card>
  )
}

export default StartOfferCard
